interface TextProps {
  content?: string;
  align?: 'left' | 'center' | 'right';
}

export function TextBlock({ props }: { props: TextProps }) {
  // Content is admin-authored CMS content, not user input — safe for innerHTML
  if (!props.content) return null;
  const textAlign =
    props.align === 'center' ? 'text-center' : props.align === 'right' ? 'text-right' : 'text-left';
  return (
    <div
      className={`prose prose-zinc max-w-none ${textAlign}`}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}
